import { useQuery } from '@tanstack/react-query';
import { themePreferenceResponseSchema } from '../../../theme/types/themePreference.types';
import api from '../../http';

export const themePreferenceQueryKey = (userId: string | null) => ['theme-preference', userId] as const;

export const useGetThemePreference = (userId: string | null) => useQuery({
	queryKey: themePreferenceQueryKey(userId),
	enabled: Boolean(userId),
	staleTime: Infinity,
	refetchOnMount: 'always',
	refetchOnWindowFocus: false,
	queryFn: async ({ signal }) => {
		const { data } = await api.get<unknown>('/user/getThemePreference', { signal });
		return themePreferenceResponseSchema.parse(data);
	},
});
